import React from "react"

export default function ProductDescription({ description }) {
  return (
    <div dangerouslySetInnerHTML={{__html: description}} className="product-description"></div>
  )
}
